import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    heading: "Introduction",
    body: [
      "The Foundation Edit respects your privacy and is committed to protecting your personal information.",
    ],
  },
  {
    heading: "Information We Collect",
    body: [
      "We may collect names, email addresses, phone numbers, business information, billing information, and enquiry form submissions.",
    ],
  },
  {
    heading: "How We Use Information",
    body: [
      "Information may be used to respond to enquiries, deliver services, process payments, communicate updates, and improve services.",
    ],
  },
  {
    heading: "Payment Processing",
    body: [
      "Payments are securely processed through third-party payment providers. We do not store full card details.",
    ],
  },
  {
    heading: "Data Storage",
    body: [
      "Reasonable steps are taken to protect personal information from unauthorised access or misuse.",
    ],
  },
  {
    heading: "Cookies",
    body: [
      "Our website may use cookies or analytics tools to improve website performance and user experience.",
    ],
  },
  {
    heading: "Your Rights",
    body: [
      "You may request access to, correction of, or deletion of your personal information where applicable.",
    ],
  },
  {
    heading: "Contact",
    body: [],
    contact: "info@thefoundationedit.co.uk",
  },
];

export default function Privacy() {
  return (
    <LegalPage
      overline="Legal"
      title="Privacy Policy"
      lastUpdated="April 2026"
      sections={sections}
    />
  );
}
